"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
/**
 * Acts as a base class for HTML formatters, taking care of whitelisting prototype property access.
 */


var HtmlFormatter = /*#__PURE__*/function () {
  function HtmlFormatter() {
    _classCallCheck(this, HtmlFormatter);
  }

  _createClass(HtmlFormatter, [{
    key: "formatWithTemplate",
    value: function formatWithTemplate(song, template) {
      return template({
        song: song
      }, {
        allowedProtoProperties: {
          bodyLines: true,
          paragraphs: true,
          subtitle: true,
          title: true,
          value: true
        }
      });
    }
  }]);

  return HtmlFormatter;
}();

var _default = HtmlFormatter;
exports["default"] = _default;